var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"host",class:{ 'position-relative': _vm.fill, fill: _vm.fill },style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.src,"frameborder":"0"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cabc34a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/IFrame.vue
// module id = 1018
// module chunks = 24